import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const { user: authUser } = useContext(AuthContext);

  if (!authUser) {
    return <Navigate to="/login" replace />;
  }

  const { role, is_verified } = authUser;

  /* --------------------------------
   * 2️⃣ PREVENT WRONG LOGIN PAGE
   * -------------------------------- */
  if (role === 7 && location.pathname === "/login") {
    return <Navigate to="/customer-login" replace />;
  }

  if (role !== 7 && location.pathname === "/customer-login") {
    return <Navigate to="/login" replace />;
  }

  /* --------------------------------
   * 3️⃣ ADMIN ROOT REDIRECT
   * -------------------------------- */
  if (role === 1 && location.pathname === "/") {
    return <Navigate to="/superdashboard" replace />;
  }

  /* --------------------------------
   * 4️⃣ CUSTOMER ROOT REDIRECT
   * -------------------------------- */
  if (role === 7 && location.pathname === "/") {
    return <Navigate to="/custdashboard" replace />;
  }

  /* --------------------------------
   * 5️⃣ ONBOARDING RULE (UNCHANGED)
   * -------------------------------- */
  const mustCompleteOnboarding =
    [2, 4, 5].includes(role) && Number(is_verified) < 7;

  if (mustCompleteOnboarding && location.pathname !== "/onboard") {
    return <Navigate to="/onboard" replace />;
  }

  if (!mustCompleteOnboarding && location.pathname === "/onboard") {
    return <Navigate to="/" replace />;
  }

   return <Outlet />;
}


// import { Navigate, useLocation } from "react-router-dom";

// export default function ProtectedRoute({ children }) {
//   const location = useLocation();
//   const authUser = JSON.parse(localStorage.getItem("authUserData") || "null");

//   // Not logged in → go to login
//   if (!authUser) return <Navigate to="/login" replace />;

//   const { role, is_verified } = authUser;

//   // ---- ADMIN REDIRECT RULE ----
//   if (role === 1 && location.pathname === "/") {
//     return <Navigate to="/superdashboard" replace />;
//   }

//   // ---- ONBOARDING RULE ----
//   // Roles that MUST complete onboarding → role: 2, 4, 5
//   const mustCompleteOnboarding = [2, 4, 5].includes(role) && is_verified < 7;

//   // If onboarding not complete → lock access to everything except onboarding page
//   if (mustCompleteOnboarding && location.pathname !== "/onboard") {
//     return <Navigate to="/onboard" replace />;
//   }

//   // If user tries to go back to onboarding AFTER completion → redirect home
//   if (!mustCompleteOnboarding && location.pathname === "/onboard") {
//     return <Navigate to="/" replace />;
//   }

//   return children;
// }



// import { Navigate, useLocation } from "react-router-dom";

// export default function ProtectedRoute({ children }) {
//   const location = useLocation();
//   const authUser = JSON.parse(localStorage.getItem("authUserData") || "null");

//   // Not logged in → go to login
//   if (!authUser) return <Navigate to="/login" replace />;

//   const { role, is_verified } = authUser;

//   // ---- ADMIN REDIRECT RULE ----
//   if (role === 1 && location.pathname === "/") {
//     return <Navigate to="/superdashboard" replace />;
//   }

//   // ---- USER ONBOARDING RULE ----
//   // Allowed roles: 2, 4, 5 → must finish onboarding until step 5
//   const mustCompleteOnboarding = [2, 4, 5].includes(role) && is_verified < 7;

//   // Force onboarding if not completed
//   if (mustCompleteOnboarding && location.pathname !== "/onboard") {
//     return <Navigate to="/onboard" replace />;
//   }

//   // Prevent entering onboarding AFTER full completion
//   if (!mustCompleteOnboarding && location.pathname === "/onboard") {
//     return <Navigate to="/" replace />;
//   }

//   return children;
// }




// import { Navigate, useLocation } from "react-router-dom";

// export default function ProtectedRoute({ children }) {
//   const location = useLocation();
//   const authUser = JSON.parse(localStorage.getItem("authUserData") || "null");

//   // Not logged in → go to login
//   if (!authUser) return <Navigate to="/login" replace />;

//   const { role, is_verified } = authUser;

//   const needsOnboarding =
//     [2, 4, 5].includes(role) && (is_verified === null || is_verified === 0);

//   // --- ADMIN REDIRECT RULE ---
//   if (role === 1 && location.pathname === "/") {
//     return <Navigate to="/superdashboard" replace />;
//   }

//   // --- USER NEEDS TO COMPLETE ONBOARDING ---
//   if (needsOnboarding && location.pathname !== "/onboard") {
//     return <Navigate to="/onboard" replace />;
//   }

//   // --- Prevent verified users from going BACK to onboarding ---
//   if (!needsOnboarding && location.pathname === "/onboard") {
//     return <Navigate to="/" replace />;
//   }

//   return children;
// }






// import { Navigate, useLocation } from "react-router-dom";

// export default function ProtectedRoute({ children }) {
//   const location = useLocation();

//   const authString = localStorage.getItem("authUserData");
//   const authUser = authString ? JSON.parse(authString) : null;

//   if (!authUser) return <Navigate to="/login" replace />;

//   const isNotVerified = authUser?.is_verified === null;

//   if (isNotVerified && location.pathname !== "/onboard") {
//     return <Navigate to="/onboard" replace />;
//   }

//   if (!isNotVerified && location.pathname === "/onboard") {
//     return <Navigate to="/dashboard" replace />;
//   }

//   return children;
// }




// import { Navigate } from "react-router-dom";

// export default function ProtectedRoute({ children }) {
//   const auth = localStorage.getItem("authUserData");
//   const onboard = localStorage.getItem("onboard_completed");

//   if (!auth) return <Navigate to="/login" replace />;

//   if (!onboard && window.location.pathname !== "/onboard")
//     return <Navigate to="/onboard" replace />;

//   return children;
// }



// import React from "react";
// import { Navigate } from "react-router-dom";

// export default function ProtectedRoute({ children }) {
//   const authUser = JSON.parse(localStorage.getItem("authUserData"));

//   if (!authUser) return <Navigate to="/login" replace />;

//   return children;
// }
